import { FC, Fragment } from 'react';

import {
  Button,
  Content,
  Footer,
  Icon,
  Loading,
  Stack,
  Typography,
} from '@wearehelpful/ui-kit';
import { useDate, useTranslation } from '@wearehelpful/ui-localization';
import { useContextSelector } from 'use-context-selector';
import {
  useCreateSurvey,
  useGetTherapistScheduleEvent,
} from '@helpful/network';
import { RoutePath, Survey } from '@common/constants';
import { useRoute } from '@core/navigation';
import { List } from '@core/ui';

import { MatchingContext } from '../Matching.context';
import { MatchingSearch } from '../Matching.types';

import { Body, Placeholder, Image } from './Success.style';
import { SuccessParams } from './Success.types';
import IMAGE_SRC from './Success.png';

export const Success: FC = () => {
  const { t } = useTranslation();
  const { format } = useDate();

  const [{ search, params }, { push }] = useRoute<
    SuccessParams,
    MatchingSearch
  >();

  const survey = useContextSelector(MatchingContext, ({ survey }) => survey);

  const {
    isSuccess,
    isFetching,
    data: event,
  } = useGetTherapistScheduleEvent(params?.therapistId, params?.eventId);

  const { isLoading, mutate: create } = useCreateSurvey();

  const handleOnNext = () => {
    create(
      {
        data: {
          slug: Survey.TherapyIntakeBeforeYouGo,
          parentId: search.parentId,
        },
      },
      {
        onSuccess: ({ data: { id } }) => {
          push({
            params: { slug: Survey.TherapyIntakeBeforeYouGo },
            path: RoutePath.SURVEYS_DETAILS_QUESTIONS,
            search: { ...search, id },
          });
        },
      }
    );
  };

  return (
    <Fragment>
      <Loading loading={isFetching} />
      {isSuccess && (
        <Fragment>
          <Content>
            <Content.Fixed inset>
              <Stack spacing={6}>
                <Typography variant="h2" align="center">
                  {t('subheadings.therapistsMatchingSuccess.title')}
                </Typography>
                <Body>
                  {t('subheadings.therapistsMatchingSuccess.description', {
                    email: survey?.response?.email,
                  })}
                </Body>
                <List>
                  <List.Item lines="none">
                    <List.Thumb color="white100" size="sm">
                      <Icon name="time" />
                    </List.Thumb>
                    <List.Label>
                      {t('forms.range', {
                        from: format({
                          value: event?.start.dateTime,
                          format: 'LLLL',
                        }),
                        to: format({
                          value: event?.end?.dateTime,
                          format: 'LT',
                        }),
                      })}
                    </List.Label>
                  </List.Item>
                </List>
                <Placeholder>
                  <Image src={IMAGE_SRC} alt="" />
                </Placeholder>
              </Stack>
            </Content.Fixed>
          </Content>
          <Footer>
            <Button loading={isLoading} onClick={handleOnNext}>
              {t('actions.next')}
            </Button>
          </Footer>
        </Fragment>
      )}
    </Fragment>
  );
};
